import React from "react";

import BEM from "./AnalyticsButton.module.scss";

export const AnalyticsButton = (props) => {
  return (
    <button
      {...props}
      className={BEM.BLOCK + " " + (props.className ? props.className : "")}
      type="button"
    >
      <span className={BEM.icon}></span>
    </button>
  );
};
